/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import ViewModel from "../../ViewModels/ViewModel";
import ImageProps from "./ImageProps";
import ImageState, { createInitialState } from "./ImageState";

export default class ImageModel extends ViewModel<ImageState> {
    public constructor(_props: ImageProps) {
        super({
            initialState: createInitialState(),
        })
    }

    public blendeBildEin = () => {
        this.setState((nextState) => nextState.isOpen = true);
    }

    public blendeBildAus = () => {
        this.setState((nextState) => nextState.isOpen = false);
    }
}
